import React from 'react';
import { Box, Card, Grid } from '@mui/material';
import Page from '~/src/components/PageLayout';
import { UpdatePaymentMethodButton } from '~/src/pages/Settings/subpages/SettingsSubscription/UpdatePaymentMethodButton';
import { useStore } from '~/src/hooks/useMst';

export const Subscribe = () => {
  const store = useStore();
  const isAdmin = store.user.currentOrganization?.admin;

  return (
    <Page showNavigation={false} title={'Subscribe'}>
      <Box display={'flex'} justifyContent={'center'}>
        <Box maxWidth={'90%'} width={'900px'}>
          <Grid item xs={10} md={5}>
            <Card>
              <Box p={3}>
                <Box py={2}>
                  {isAdmin
                    ? 'You have no active subscription. Please update your payment method to reactivate your subscription.'
                    : 'You have no active subscription. To enquire about your subscription, please contact Clio support.'}
                </Box>
                {isAdmin && (
                  <Box pt={2}>
                    <UpdatePaymentMethodButton />
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Box>
      </Box>
    </Page>
  );
};
